/**
 * Everything that would change if this stopped being called "VozQI".
 *
 * The name is a working title for customer interviews in Panama, not
 * branding, so it lives in one place and nothing else hard-codes it. It sits
 * in `shared` because BOTH clients read it.
 *
 * NO VERSION HERE: a copy by hand drifted from `app.json`. The phone reads its
 * binary's (`appVersion`), the web its build's (`getRelease`). The one copy
 * left, the ceiling /ops checks against, is `MOBILE_BINARY_VERSION` in
 * app-version.ts, and a test ties it to `app.json`.
 */
export const APP = {
    name: "VozQI",
    tagline: "Tus cuentas, en orden.",
    // Google Play requires a privacy policy URL; both clients read the same addresses.
    legal: {
        termsUrl: "https://vozqi.com/terminos",
        privacyUrl: "https://vozqi.com/privacidad",
        // Términos §5, what «Aceptar y conectar» accepts on «Tu PAC». The server records the
        // version with the acceptance (app.fiscal_connection.terms_version): bump it with the text.
        invoicingTermsUrl: "https://vozqi.com/terminos#facturacion",
        invoicingTermsVersion: "4.1",
    },
    // Where the phone app is downloaded. The Android package still says `cuotas`
    // on purpose (see CLAUDE.md); the App Store link is by Apple ID, not bundle id.
    stores: {
        appStore: "https://apps.apple.com/app/id6818192079",
        googlePlay: "https://play.google.com/store/apps/details?id=com.fusiqo.cuotas",
        // App Store Connect's provider token (App Analytics, Campaign Links).
        // With it a badge's link carries the campaign (`pt` and `ct`) and App
        // Store Connect counts installs by campaign; without it the link is the
        // plain listing. Public -- every campaign link prints it -- so it lives
        // here, beside the address it completes.
        appStoreProviderToken: "129545373",
    },
};
/**
 * The name a business is born with, before its owner gives it one.
 *
 * Here rather than in the backend alone because a CLIENT reads it: the
 * basic front page's checklist ticks «Ponle nombre a tu negocio» off by
 * comparing against exactly this string, and a literal copied into the web
 * would drift the day the backend's did. The backend writes it on creation
 * and restores it when a sample is cleared; the web only ever compares.
 */
// «Sin nombre», not «Mi negocio»: the row exists before anybody says what it
// is, and «Mi negocio» would be wrong in a church's own header until it is
// renamed.
export const DEFAULT_BUSINESS_NAME = "Sin nombre";
